'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/copy/Copy.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CopyIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.168 4.49999V1.83333H3.16797V11.5H5.83464",
          stroke: "currentColor",
          strokeWidth: "1.2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.832 4.5H5.83203V14.1667H12.832V4.5Z",
          stroke: "currentColor",
          strokeWidth: "1.2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  })
);

export {
  CopyIcon
};
//# sourceMappingURL=chunk-2WXCP5VS.mjs.map